import { isAppCti, permissionNotificationsGranted } from 'flow/utils/app-utils';
import { List, Map } from 'immutable';

export const getIntegrationContactMetaDataByNumber = (state, number) => {
    const contact = getSelectedCtiContactByNumber(state, number);
    return contact && contact.get('metadata', Map()).toJS();
};

export const getIntegrationContacts = (state) => {
    return state.integration.get('integrationContacts');
};

export const getSelectedCtiContactByNumber = (state, number) => {
    return getSelectedCtiContactByNumberFromIntegration(
        state.integration,
        number,
    );
};

export const getContactIsCtiIntegrationContact = (state, number) => {
    const integrationContact = getSelectedCtiContactByNumber(state, number);
    return !!(integrationContact && !integrationContact.isEmpty());
};

export const getSelectedCtiContactByNumberFromIntegration = (
    integrationState,
    number,
) => {
    return integrationState
        .getIn(['integrationContacts', number], List())
        .find((contact) => contact.get('isSelected'), null, null);
};

export const getIntegrationContactsFromStateByNumber = (state, number) => {
    return state.integration.getIn(['integrationContacts', number], null);
};

export const getIntegrationConfig = (state) => {
    return state.integration.get('integrationConfig', Map());
};

export const wrapperIsRegistered = (state) => {
    return state.integration.get('targetOrigin', null) !== null;
};

export const getShowNotificationsGrantedBanner = (state) => {
    const isEmbeddedIntegration = isAppCti(state);
    const inWindow = 'Notification' in window;
    return (
        !permissionNotificationsGranted(
            inWindow,
            inWindow ? Notification : undefined,
        ) && isEmbeddedIntegration
    );
};

export const getShowCrmIntegrationFeatureBanner = (state) => {
    const isEmbeddedIntegration = isAppCti(state);

    const showBannerDate = new Date('2021-10-01');
    const startShowingFromOctoberFirst = new Date() >= showBannerDate;

    return (
        startShowingFromOctoberFirst &&
        isEmbeddedIntegration &&
        !state.app.getIn(['extension', 'hasCtiIntegrationFeature'])
    );
};

export const hasTooManyInstances = (state) => {
    return state.integration.get('tooManyInstances', false);
};

export const allowCtiCommunication = (
    state,
    shutdownDate = new Date('2021-12-01'),
) => {
    const shutdownFromDecemberFirst = new Date() >= shutdownDate;
    const hasCtiIntegrationFeature = state.app.getIn([
        'extension',
        'hasCtiIntegrationFeature',
    ]);
    if (!hasCtiIntegrationFeature && shutdownFromDecemberFirst) {
        return false;
    }
    return true;
};
